import React from 'react';
import {
  STATUS_LABELS, STATUS_COLORS, PAYMENT_MODE_LABELS,
  fmtRupees, fmtDate, shortId, holdBadges, ACTIONS_BY_STATUS, ACTION_LABELS,
} from '../../utils/payoutFormat';
import { payoutRefLabel } from '../../utils/payoutReference';

const th = { textAlign: 'left', padding: '10px 12px', fontSize: 12, color: '#6b7280', fontWeight: 600, whiteSpace: 'nowrap', borderBottom: '1px solid #e5e7eb' };
const td = { padding: '10px 12px', fontSize: 13, color: '#374151', borderBottom: '1px solid #f3f4f6', verticalAlign: 'top' };

const actionBtn = { marginRight: 6, padding: '3px 10px', fontSize: 12, fontWeight: 600, border: '1px solid #d1d5db', borderRadius: 5, background: '#fff', color: '#374151', cursor: 'pointer' };

// List of session payout lines. Healer names come from the summary endpoint.
// Released lines can be ticked (one healer at a time) to mark them paid; other actions are per row.
const PayoutLinesTable = ({ lines, healerNames, selected, selectedHealerId, onToggle, onAction }) => {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 960 }}>
        <thead>
          <tr>
            <th style={th}></th>
            <th style={th}>Healer</th>
            <th style={th}>Session</th>
            <th style={th}>Logged on</th>
            <th style={th}>Base amount</th>
            <th style={th}>Share</th>
            <th style={th}>Healer amount</th>
            <th style={th}>Status</th>
            <th style={th}>Hold until</th>
            <th style={th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {lines.map(function(line) {
            const colors = STATUS_COLORS[line.status] || STATUS_COLORS.cancelled;
            const badges = line.status === 'on_hold' ? holdBadges(line) : [];
            return (
              <tr key={line._id}>
                <td style={td}>
                  {line.status === 'released' && (
                    <input type="checkbox" aria-label={'Select session ' + line.sessionNumber + ' to mark as paid'}
                      checked={selected.indexOf(line._id) !== -1}
                      disabled={!!selectedHealerId && selectedHealerId !== line.healerId}
                      onChange={function() { onToggle(line); }} />
                  )}
                </td>
                <td style={td}>{healerNames[line.healerId] || 'Healer ' + shortId(line.healerId)}</td>
                <td style={td}>#{line.sessionNumber} · request {shortId(line.healingRequestId)}</td>
                <td style={td}>{fmtDate(line.createdAt)}</td>
                <td style={td}>{fmtRupees(line.baseAmount)}</td>
                <td style={td}>{line.sharePercent}%</td>
                <td style={Object.assign({}, td, { fontWeight: 600 })}>{fmtRupees(line.amount)}</td>
                <td style={td}>
                  <span style={{ background: colors.bg, color: colors.fg, padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {STATUS_LABELS[line.status] || line.status}
                  </span>
                  {line.status === 'paid' && (
                    <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>
                      {fmtDate(line.paidAt)}{line.paymentMode ? ' · ' + (PAYMENT_MODE_LABELS[line.paymentMode] || line.paymentMode) : ''}
                    </div>
                  )}
                  {line.status === 'paid' && payoutRefLabel(line.paymentReference) && (
                    <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{payoutRefLabel(line.paymentReference)}</div>
                  )}
                  {badges.map(function(b) {
                    return <div key={b} style={{ fontSize: 11, color: '#92400e', marginTop: 4 }}>⚑ {b}</div>;
                  })}
                </td>
                <td style={td}>{line.status === 'on_hold' ? fmtDate(line.holdWindowUntil) : '—'}</td>
                <td style={td}>
                  {(ACTIONS_BY_STATUS[line.status] || []).map(function(a) {
                    return <button key={a} onClick={function() { onAction(a, line); }} style={actionBtn}>{ACTION_LABELS[a]}</button>;
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PayoutLinesTable;
